module.exports = __webpack_public_path__ + "static/media/vent-direccio.c6eb4e97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vent-direccio.svg
// module id = 198
// module chunks = 0